export const DASHBOARDS_OPENED_KEY = 'grafana.scopes.dashboards.opened';
